import React, { useContext, useEffect, useState } from "react";
import StarRating from "../../SingleProduct/StarRating";
import { useDispatch } from "react-redux";
import { Context } from "../../../utils/context";
import { addToWishlist } from "../../../utils/feature/wishlistSlice";
import { FaCartPlus } from "react-icons/fa";
import { Button } from "@mui/material";

const calculateAverageRating = (reviews) => {
  const totalRatings = reviews?.reduce((acc, curr) => acc + curr.rating, 0);
  const averageRating = totalRatings / reviews?.length;
  return { total: reviews?.length, average: averageRating.toFixed(2) };
};

const SizeVariation = ({ data }) => {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const { handleAddToCart } = useContext(Context);
  const [imageurl, setImageurl] = useState("");
  const { total, average } = calculateAverageRating(data?.reviews);
  const [imageUrls, setImageUrls] = useState([]);
  const [size, setSize] = useState("");

  const decrement = () => {
    setQuantity((prevState) => {
      if (prevState === 1) return 1;
      return prevState - 1;
    });
  };
  const increment = () => {
    setQuantity((prevState) => prevState + 1);
  };
  const getDiscount = (price, originalPrice) => {
    const value = parseInt((price * 100) / originalPrice);
    return Math.abs(value - 100);
  };

  const handleAddingToCart = () => {
    const formData = {
      productID: data?._id,
      variationID: size?._id,
      name: data?.name,
      shortDescription: data?.shortDescription,
      description: data?.description,
      productType: data?.productType,
      images: data?.images,
      price: size?.originalPrice,
      originalPrice: size?.price,
      discount: getDiscount(size?.price, size?.originalPrice),
      color: data?.color,
      size: size?.size || "",
      quantity: quantity,
      inventory: size?.inventory,
      shipping_details: data?.shipping_details,
      categories: data?.categories,
      relatedProducts: data?.relatedProducts,
    };

    handleAddToCart(formData, quantity);
  };

  useEffect(() => {
    if (data) {
      setImageurl(data?.images?.featuredImage?.src);
      setImageUrls([data?.images?.featuredImage, ...data?.images?.images]);
      setSize(data?.variations[0]);
    }
  }, [data]);
  return (
    <div className=" single-product-page  overflow-hidden  gap-2">
      <div
        className="   md:w-60  md:space-y-2  hidden md:block  overflow-hidden overflow-y-auto no-scrollbar  gap-5  h-[22rem]    "
        style={{ width: "100%" }}
      >
        {imageUrls?.map((imageUrl, index) => (
          <div
            className="w-16  border-2 px-1 py-1 rounded-md cursor-pointer "
            onClick={() => setImageurl(imageUrl?.src)}
          >
            <img
              className=" object-contain "
              key={index}
              src={imageUrl?.src}
              alt={imageUrl?.alt}
            />
          </div>
        ))}
      </div>
      <div className="left     rounded-md  ">
        <img
          className="  object-contain w-full h-96  "
          src={imageurl || data.images[0]?.featuredImage?.src}
        />
      </div>
      <div className=" md:w-16 md:space-y-5 flex   justify-left gap-5 w-full items-center md:block  max-h-96   ">
        {imageUrls?.map((imageUrl, index) => {
          return (
            <div
              className=" block md:hidden w-16    border-2 px-1 py-1 rounded-md cursor-pointer"
              onClick={() => setImageurl(imageUrl?.src)}
              key={index}
            >
              <img className="" src={imageUrl?.src} alt={imageUrl?.alt} />
            </div>
          );
        })}
      </div>

      <div className="right">
        <span className="name line-clamp-2 ">{data?.name}</span>
        <div className=" flex justify-between pr-10">
          <div>
            <span className="price justify-center">
              {data?.variations
                ?.filter(
                  (item) =>
                    item?.size === (size?.size || data?.variations[0]?.size)
                )
                ?.map((el, index) => {
                  return (
                    <div>
                      &#8377;{el?.price || 0}
                      <span className="  line-through  text-gray-400 ml-2   text-lg">
                        &#8377;{el?.originalPrice || 0}
                      </span>
                      <span className="text-red-400 ml-2   text-lg sm:text-lg">
                        ({getDiscount(el?.price, el?.originalPrice) || 0}% Off)
                      </span>
                    </div>
                  );
                })}
            </span>
          </div>
          <div className="   flex  justify-center items-center gap-2  text-lg sm:text-2xl">
            <StarRating rating={average} />
            <p className=" text-sm">({total})</p>
          </div>
        </div>
        <span
          className="desc line-clamp-2  "
          dangerouslySetInnerHTML={{ __html: data?.shortDescription }}
        />
        <span className="desc line-clamp-3 ">
          <span className=" text-red-400 pr-2">
            <ion-icon name="trophy-outline"></ion-icon>
          </span>
          1 Year AL Jazeera Brand Warranty
        </span>
        <span className="desc line-clamp-3 ">
          <span className=" text-red-400 pr-2">
            <ion-icon name="storefront-outline"></ion-icon>
          </span>
          30 Day Return Policy
        </span>
        <span className="desc line-clamp-3">
          <span className=" text-red-400 pr-2">
            <ion-icon name="wallet-outline"></ion-icon>
          </span>
          Cash on Delivery available
        </span>

        <div className="flex items-center gap-2">
          <span className="font-bold mr-2">Size:</span>
          {data?.variations?.map((sz, index) => {
            return (
              <Button
                key={index}
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "10px",
                  bgcolor: size?.size === sz?.size ? "" : "grey",
                }}
                onClick={() => {
                  setSize(sz);
                }}
                disabled={sz?.stock <= 0}
              >
                {sz?.size}
              </Button>
            );
          })}
        </div>

        <span className="divider" />

        <div className="cart-buttons">
          <div className="quantity-buttons">
            <span onClick={decrement}>-</span>
            <span>{quantity}</span>

            <span onClick={increment}>+</span>
          </div>
          <button
            style={{
              width: "120px",
              padding: "2px 2px",
              margin: "0px 5px",
            }}
            className=" add-to-cart-button2 text-xs  lg:text-[16px] bg-[#333333]"
            onClick={() => {
              dispatch(addToWishlist(data));
            }}
          >
            Wishlist
          </button>
          <button
            className="add-to-cart-button text-xs  lg:text-[16px] bg-[#FF324D]"
            onClick={async () => {
              handleAddingToCart();
            }}
          >
            <span className=" hidden md:block">
              <FaCartPlus size={20} />
            </span>
            <span className=" md:hidden block">
              <FaCartPlus size={15} />
            </span>
            ADD TO CART
          </button>
        </div>

        <span className="divider" />
      </div>
    </div>
  );
};

export default SizeVariation;
